module.exports = __webpack_public_path__ + "img/Expo_Topic4.db3960bf.png";